import {OnBoardingTooltipModel} from "../on-boarding-tooltip.model";
import {IOnBoardingTooltipsContainer} from "../on-boarding-tooltips-container.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {IconTitleTextTooltip} from "../../../../components/tooltip/tooltips/icon-title-text/icon-title-text.tooltip";
import {CyClass} from "../../../../../common/cy-classes";
import {TimeSpan} from "@sparkware/app-utils";
import {makeObservable} from "mobx";
import React from "react";
import {AreaType} from "@sparkware/uc-sdk-core";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../common/const/casinofied-analytics-consts";
import {
    TOOLTIP_TARGET_CONTROL_CENTER_PC_BUTTON,
    TOOLTIP_TARGET_HEADER_BANKROLL_BUTTON_MOBILE
} from "../on-boarding-tooltip-target-selectors";

export class ControlCenterOnBoardingTooltipModel extends OnBoardingTooltipModel {
    constructor(tooltipsContainer: IOnBoardingTooltipsContainer,
                services: IServiceFactoryExtended) {

        super(tooltipsContainer, services, {
            renderContent: () => {
                const Icon =  services.theme.currentTheme.icons.controlCenterIcon
                return (<IconTitleTextTooltip icon={<Icon/>}
                                              title={services.translation.translate("SAFE_ZONE")}
                                              text={services.translation.translate("CONTROL_CENTER_ONBOARDING_TOOLTIP_TEXT")}
                                              onClick={this._onTooltipClicked}
                                              className={CyClass('cy-control-center-on-boarding-tooltip')}/>);
            },
            timeout: TimeSpan.fromSeconds(7),
            localStorageKey: 'control_center_on_boarding_tooltip',
            maximumDisplayCount: 2,
            showOverlay: true,
            showCloseButton: false,
            closeOnClickOutside: true,
            animated: true,
        });

        makeObservable(this);
    }

    shouldDisplay(): boolean {
        const commonConditions = super.shouldDisplay();
        const isControlCenterEnabled = this.services.controlCenter.isEnabled;
        const isMiniOrbit = this.services.miniOrbit.isEnabled;
        const isControlCenterOnBoardingTooltipEnabled = this.services.configuration.servicesConfigs.OnBoardingTooltips.enabledForControlCenter;
        return commonConditions && isControlCenterEnabled && !isMiniOrbit && isControlCenterOnBoardingTooltipEnabled;
    }

    protected _getElementToAttach(): HTMLElement | null {
        const element = this.services.dom.querySelector(`.${TOOLTIP_TARGET_HEADER_BANKROLL_BUTTON_MOBILE}`) as HTMLElement;

        if(element) {
            return element;
        }

        return this.services.dom.querySelector(`.${TOOLTIP_TARGET_CONTROL_CENTER_PC_BUTTON}`) as HTMLElement;

    }

    onToolTipRendered(tooltipContainer: HTMLElement) {
        super.onToolTipRendered(tooltipContainer);
        this.services.analytics.sendOrbitUserFlowEvent("Tooltip", "Show", "CC_Bubble");
    }

    private _onTooltipClicked = async () => {
        this.closeTooltip();
        this.services.analytics.sendOrbitUserFlowEvent("Tooltip", "Click", "CC_Bubble");
        if(this.services.mediaQuery.lAndBelow) {
            this.services.userMenu.openMenu();
        } else {
            await this.services.appLauncher.openControlCenterFull({
                businessCorrelationID: this.services.tools.getGuid(),
                channel: {
                    area: AreaType.Header,
                    element: CHANNEL_ELEMENTS.controlCenterTooltip,
                    source: CHANNEL_SOURCE.casinoClient
                }
            });
        }
    }
}